import { useDispatch } from 'react-redux';
import { fetchSuggestions } from '@client/catalog/redux/suggestions/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export function useFetchSuggestionsAction(): typeof fetchSuggestions {
  const dispatch = useDispatch();
  return bindActionCreators(fetchSuggestions, dispatch);
}
